import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'

//获取新闻列表
export function queryArticleList(data) {
    return http.request({
        url: common.url + '/papi/article/list',
        method: 'get',
        params: data
    })
}

//获取文章根据id
export function queryArticleById(data) {
    return http.request({
        url: common.url + '/papi/article/queryArticleByArticleId',
        method: 'get',
        params: data
    })
}

//最新10条
export function latestArticleList(data) {
    return http.request({
        url: common.url + '/papi/article/latestArticleList',
        method: 'get',
        params: data
    })
}